import { withDependencies, named } from '@wix/thunderbolt-ioc'
import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import type { ServiceProvider, PlatformConfig, ILogger, ICurrentRouteInfo } from '@wix/thunderbolt-symbols'
import { CurrentRouteInfoSymbol, LoggerSymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IUrlDefinition } from '@wix/viewer-service-url/definition'
import { UrlDefinition as definition } from '@wix/viewer-service-url/definition'
import { UrlService as impl } from '@wix/viewer-service-url/implementations'
import { queryParamsWhitelist } from '@wix/thunderbolt-commons'
import type { UrlServiceSiteConfig } from '@wix/viewer-services-configs/configs'
import { name } from './symbols'

export const urlService: FactoryWithDependencies<ServiceProvider<IUrlDefinition, typeof impl>> = withDependencies(
	[LoggerSymbol, CurrentRouteInfoSymbol, named(SiteFeatureConfigSymbol, name)],
	(
		logger: ILogger,
		currentRouteInfo: ICurrentRouteInfo,
		{ requestUrl, externalBaseUrl }: UrlServiceSiteConfig
	): ServiceProvider<IUrlDefinition, typeof impl> => {
		const config = {
			requestUrl,
			externalBaseUrl,
			queryParamsWhitelist,
			logger,
			currentRouteInfo,
		}
		return {
			definition,
			impl,
			config,
			platformConfig: config as any as PlatformConfig,
			hasNonSerializablePlatformConfig: true,
		}
	}
)

export { definition, impl }
